export const columnsDataCheck = [
  {
    Header: "NAME",
    accessor: "name",
  },
  {
    Header: "PROGRESS",
    accessor: "progress",
  },
  {
    Header: "QUANTITY",
    accessor: "quantity",
  },
  {
    Header: "CATEGORY", // 새로운 컬럼
    accessor: "category",
  },
];


export const columnsDataComplex = [
  {
    Header: "NAME",
    accessor: "name",
  },
  {
    Header: "INVENTORY STATUS",
    accessor: "status",
  },
  {
    Header: "CATEGORY", // 새로운 컬럼
    accessor: "category",
  },

  
  {
    Header: "PRICE",
    accessor: "price",
  },

  {
    Header: "PROGRESS",
    accessor: "progress",
  },
];
